import { ADDRESSLINE1_MAX_ERR } from '../../../constants';
import data from '../../../json-data/address.json';

export const addAutoCompleteCityToDropdownIfMissing = (
  autoCompleteCountry,
  autoCompleteState,
  autoCompleteCity
) => {
  if (autoCompleteCountry && autoCompleteState) {
    let cityPresent = false;
    data[autoCompleteCountry].forEach((e) => {
      if (e.stateInitial === autoCompleteState) {
        for (const city of e.city) {
          if (city === autoCompleteCity) {
            cityPresent = true;
            break;
          }
        }
      }
    });
    return cityPresent;
  }
  return false;
};

export const returnCityList = (
  element,
  addressInformation,
  personalInformation,
  beneficiaryData
) => {
  const cityList = [];
  if (element === 'permanentCity' && addressInformation?.permanentCountry) {
    data[addressInformation.permanentCountry].forEach((e) => {
      if (
        addressInformation?.permanentState &&
        e.stateInitial === addressInformation.permanentState
      ) {
        e.city.sort().map((city) => cityList.push(city));
      }
    });
  }
  if (element === 'permanentCity' && beneficiaryData?.addressInfo?.beneficiaryCountry) {
    data?.[beneficiaryData?.addressInfo?.beneficiaryCountry]?.forEach((e) => {
      if (
        beneficiaryData?.addressInfo?.beneficiaryState &&
        e.stateInitial === beneficiaryData?.addressInfo?.beneficiaryState
      ) {
        e.city.sort().map((city) => cityList.push(city));
      }
    });
  }
  if (element === 'city' && addressInformation?.country) {
    data?.[addressInformation.country]?.forEach((e) => {
      if (addressInformation.state && e.stateInitial === addressInformation?.state) {
        e.city.sort().map((city) => cityList.push(city));
      }
    });
    if (personalInformation?.missingVouchedCity) {
      cityList.push(personalInformation.missingVouchedCity);
    }
  }
  if (addressInformation?.missingAutoCompleteCity) {
    cityList.push(addressInformation.missingAutoCompleteCity);
  }
  return cityList;
};

export const returnStateList = (
  element,
  addressInformation,
  personalInformation,
  beneficiaryData,
  isBeneficiaryAddress
) => {
  const stateList = [];
  const stateListData = (country) => {
    if (country) {
      data?.[country]?.forEach((e) => {
        const stateDetails = {
          stateInitial: e.stateInitial,
          stateFullName: e.stateFullName,
        };
        stateList.push(stateDetails);
      });
    }
  };

  if (element === 'permanentState') {
    stateListData(
      isBeneficiaryAddress
        ? beneficiaryData?.addressInfo?.beneficiaryCountry
        : addressInformation?.permanentCountry
    );
  }
  if (element === 'state') {
    stateListData(addressInformation?.country);
  }
  return stateList;
};

export const tooltipStyle = {
  marginLeft: '10px',
  position: 'absolute',
};

export const tooltipMailingText =
  'Address where you will receive your debit card and other mail from the bank.';
const getPermanentCountry = (addressObject) => {
  let permanentCountry1;
  if (addressObject.Address.CountrySubdivisionCode === 'US-PR') {
    permanentCountry1 = 'PR';
  } else if (addressObject.Address.CountrySubdivisionCode === 'US-VI') {
    permanentCountry1 = 'VI';
  } else {
    permanentCountry1 = 'USA';
  }
  return permanentCountry1;
};
const getPermanentState = (addressObject, permanentCountry) => {
  let permanentState1;
  if (addressObject.Address.State) {
    if (permanentCountry === 'VI' || permanentCountry === 'PR') {
      permanentState1 = 'N/A';
    } else {
      permanentState1 = addressObject.Address.State;
    }
  }
  return permanentState1;
};
/** Mailing address suggestion
 */
export const handleMailingSuggestion = (
  addressObject,
  setAddress,
  setAddressErrors,
  isBeneficiaryAddress
) => {
  if (addressObject) {
    let permanentCity = '';
    let permanentState = '';
    let permanentCountry = '';
    let permanentZipCode = '';
    let permanentAddress1 = '';
    if (addressObject.Address.AddressLine1) {
      permanentAddress1 = addressObject.Address.AddressLine1?.trim() || '';
    }
    if (addressObject?.Address?.AddressLine1?.length > 30) {
      isBeneficiaryAddress
        ? setAddressErrors((prevState) => ({
            ...prevState,
            addressInfo: {
              ...prevState?.addressInfo,
              beneficiaryAddress1: ADDRESSLINE1_MAX_ERR,
              beneficiaryCity: '',
              beneficiaryCountry: '',
              beneficiaryState: '',
              beneficiaryZipCode: '',
            },
          }))
        : setAddressErrors((prevState) => ({
            ...prevState,
            permanentAddress1: ADDRESSLINE1_MAX_ERR,
            permanentCity: '',
            permanentCountry: '',
            permanentState: '',
            permanentZipCode: '',
          }));
    } else {
      isBeneficiaryAddress
        ? setAddressErrors((prevState) => ({
            ...prevState,
            addressInfo: {
              ...prevState?.addressInfo,
              beneficiaryAddress1: '',
              beneficiaryCity: '',
              beneficiaryCountry: '',
              beneficiaryState: '',
              beneficiaryZipCode: '',
            },
          }))
        : setAddressErrors((prevState) => ({
            ...prevState,
            permanentAddress1: '',
            permanentCity: '',
            permanentCountry: '',
            permanentState: '',
            permanentZipCode: '',
          }));
    }
    if (addressObject.Address.PostalCode) {
      permanentZipCode = addressObject.Address.PostalCode.split('-')[0];
    }
    permanentCountry = getPermanentCountry(addressObject);
    permanentState = getPermanentState(addressObject, permanentCountry);
    if (addressObject.Address.City) {
      permanentCity = addressObject.Address.City;
    }
    const cityPresent = addAutoCompleteCityToDropdownIfMissing(
      permanentCountry,
      permanentState,
      permanentCity
    );

    if (!cityPresent) {
      isBeneficiaryAddress
        ? setAddress((prevState) => ({
            ...prevState,
            addressInfo: {
              ...prevState?.addressInfo,
              missingMalingAutoCompleteCity: permanentCity,
            },
          }))
        : setAddress((prevState) => ({
            ...prevState,
            missingMalingAutoCompleteCity: permanentCity,
          }));
    }
    if (isBeneficiaryAddress) {
      setAddress((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryAddress1: permanentAddress1,
          beneficiaryCity: permanentCity,
          beneficiaryCountry: permanentCountry,
          beneficiaryState: permanentState,
          beneficiaryZipCode: permanentZipCode,
        },
      }));
      setAddressErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCity: '',
          beneficiaryCountry: '',
          beneficiaryState: '',
          beneficiaryZipCode: '',
        },
      }));
    } else {
      setAddress((prevState) => ({
        ...prevState,
        permanentAddress1,
        permanentCity,
        permanentCountry,
        permanentState,
        permanentZipCode,
      }));
      setAddressErrors((prevState) => ({
        ...prevState,
        permanentCity: '',
        permanentCountry: '',
        permanentState: '',
        permanentZipCode: '',
      }));
    }
  }
};
